import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" id=\"icon-refresh\"><g stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M2.15 7c.467-3.11 3.278-5.5 6.675-5.5 3.203 0 5.987 2.15 6.675 5\" /><path d=\"M5.5 7.5h-4v-4M14.815 10c-.47 3.11-3.302 5.5-6.724 5.5-3.235 0-5.941-2.135-6.626-4.995\" /><path d=\"M11.5 9.5h4v4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol